// A password reset code is valid only together with the pending token the backend returned to the browser
// that requested it. localStorage keeps it across tabs, e.g. when the user opens the reset page again.
const LS_PASSWORD_RESET_PENDING_TOKEN = 'passwordResetPendingToken';

export function savePasswordResetPendingToken(token) {
  if (!token) {
    return;
  }
  try {
    localStorage.setItem(LS_PASSWORD_RESET_PENDING_TOKEN, token);
  } catch (e) {
    // Storage may be unavailable (private window, blocked site data)
  }
}

export function loadPasswordResetPendingToken() {
  try {
    return localStorage.getItem(LS_PASSWORD_RESET_PENDING_TOKEN) || '';
  } catch (e) {
    return '';
  }
}

export function clearPasswordResetPendingToken() {
  try {
    localStorage.removeItem(LS_PASSWORD_RESET_PENDING_TOKEN);
  } catch (e) {
    // Storage may be unavailable (private window, blocked site data)
  }
}
